module.exports = __webpack_public_path__ + "img/full2-min.a348efb9.png";